import { useRef } from "react";

type CompareFunc<T> = (a: T, b: T) => boolean;
type RefType<T> = {
  current?: T;
  prev?: T;
};

export default function usePrevious<T>(value: T, initial?: T, cmpFunc?: CompareFunc<T>) {
  const ref = useRef<RefType<T>>({ current: initial });

  const cur = ref.current.current;
  if (!cur || (cmpFunc && !cmpFunc(value, cur)) || value != cur) {
    ref.current = {
      current: value,
      prev: ref.current.current,
    };
  }

  return ref.current.prev;
}
